import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en/translation.json';
import translationDE from './locales/de/translation.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: translationEN },
    de: { translation: translationDE },
  },
  lng: 'en', // default language
  fallbackLng: 'en', // fallback language if the selected language is unavailable
  interpolation: { escapeValue: false }, // React already escapes values
});

export default i18n;